

























import Vue from "vue";
import Component from "vue-class-component";
import { challengesState, challengeModule } from "@/utils/store-acessor";
import { ChallengeModel } from "@/models/challenge.model";
import ChallengesSituationsTemplate from "@/components/Challenges/ChallengesSituationsTemplate.vue";
import NavBar from "@/components/NavBar";
import { esic } from "@/locales/pt-br/esic.locale.ts";

interface SearchResult {
  key: string;
  name: string;
  value: string;
}

@Component({
  components: {
    NavBar,
    ChallengesSituationsTemplate
  }
})
export default class Challenges extends Vue {
  @challengeModule.Getter("challenges") challenges!: ChallengeModel[];
  @challengeModule.Getter("lastPage") lastPage!: number;
  @challengeModule.Getter("currentPage") page!: number;
  @challengeModule.Getter("loading") loading!: boolean;
  @challengeModule.Getter("challengesByTag") challengesByTag!: (tag: string) => ChallengeModel[];

  get tag(): string | null {
    return this.$route.query?.tag?.toString() || null;
  }

  get emptyMessage(): string {
    return !!this.tag
      ? this.$t("challenge.labels.no_challenges_in_progress_with_tag", [this.tag]).toString()
      : this.$t("challenge.labels.no_challenges_in_progress").toString();
  }

  get challengesFiltered(): ChallengeModel[] {
    return this.challenges;
  }

  get esicResults(): SearchResult[] {
    return this.searchEsicLocale();
  }

  navigateToTransparencia(name: string) {
    this.$router.push({ path: '/transparencia', query: { activeTab: name } });
  }

  async mounted() {
    console.log("ESIC RESULTS:::::::::", this.esicResults);
    this.makeRequest(1);
  }

  private async makeRequest(page: number = 1) {
    const tag = this.$route.query?.tag?.toString();
    await challengesState.fetchBySearch({
      page,
      tag
    });
  }

  searchEsicLocale(): SearchResult[] {
    const searchQuery = this.$route.query?.tag?.toString().toLowerCase();
    const results: SearchResult[] = [];
    const snippetLength = 30;

    function searchObject(obj: any) {
      for (const key in obj) {
        if (obj[key] && typeof obj[key] === "object") {
          const { name, content } = obj[key];
          if (content && content.toLowerCase().includes(searchQuery)) {
            const plainTextContent = stripHtmlTags(content);
            const snippet = createSnippet(plainTextContent, searchQuery, snippetLength);
            results.push({ key, name, value: snippet });
          }
        }
      }
    }

    function stripHtmlTags(text: string): string {
      const div = document.createElement("div");
      div.innerHTML = text;
      return div.textContent || div.innerText || "";
    }

    function createSnippet(text: string, query: string, length: number): string {
      const queryIndex = text.toLowerCase().indexOf(query);
      const start = Math.max(0, queryIndex - length);
      const end = Math.min(text.length, queryIndex + query.length + length);
      const snippet = text.substring(start, end);
      const highlightedSnippet = snippet.replace(
        new RegExp(`(${query})`, "gi"),
        '<span class="search-highlight">$1</span>'
      );
      return (start > 0 ? "..." : "") + highlightedSnippet + (end < text.length ? "..." : "");
    }

    searchObject(esic);
    return results;
  }
}
